const cartValidation = {
  form: document.getElementById('calculatorForm') as
    | HTMLInputElement
    | undefined,
  shippingError: document.getElementById('shippingError') as HTMLElement | undefined,
  checkErorr: document.getElementById('btnError') as
    | HTMLElement
    | undefined,
  checkZip: document.getElementById('checkZip') as HTMLElement | undefined,
  checkoutBtn: document.getElementById('checkoutBtn') as
    | HTMLElement
    | undefined,
  checkoutBtnDummy: document.getElementById('checkoutBtnDummy') as
    | HTMLElement
    | undefined,
  shippingZip: document.getElementById('shippingZip') as
    | HTMLElement
    | undefined,
  init() {
    this.listiners();
  },
  validateInput() {
    if (!this.form) return;
    const select = this.form.querySelector('select');
    if (!select?.value) {
      this.shippingError!.classList.remove('d-none');
      this.checkoutBtnDummy!.classList.remove('d-none');
      this.checkoutBtn!.classList.add('d-none');
      return false;
    } else {
      this.checkoutBtnDummy!.classList.add('d-none');
      this.shippingError!.classList.add('d-none');
      this.checkoutBtn!.classList.remove('d-none');
      return true;
    }
  },
  validateZip() {
    if (!this.shippingZip) {
      this.checkErorr!.classList.remove('d-none');
      this.checkoutBtnDummy!.classList.remove('d-none');
      this.checkoutBtn!.classList.add('d-none');
      return false;
    } else {
      this.checkoutBtnDummy!.classList.add('d-none');
      this.checkErorr!.classList.add('d-none');
      this.checkoutBtn!.classList.remove('d-none');
      return true;
    }
  },
  listiners() {
    this.checkoutBtnDummy?.addEventListener('click', (e) => {
      if (!this.validateInput()) return;
      if (!this.validateZip()) return;
      this.checkoutBtn!.click();
    });
    this.checkZip?.addEventListener('click', (e) => {
      if (!this.validateInput()) {
        e.preventDefault();
      }
    });
  },
};

export default cartValidation;
